import React, { Children, Fragment, useEffect, useRef, useState } from "react";
import Bubble from "components/Creation/components/What/components/BubblesGrid/components/Bubble";
import { FiPlus } from "react-icons/fi";
import moment from "moment";
import useBookings from "hooks/useBookings";
import MirumTabsGroup from "components/MirumTabs";
import TabItem from "components/MirumTabs/components/TabItem";
import MirumModal from "components/MirumModal";

const Bookings = ({
  bookings,
  loadAndGoToBooking,
  deleteBooking,
  onClickedNewSurprise,
  showStatus,
}) => {
  const [tabsSelectedIndex, setTabsSelectedIndex] = useState(null);
  const [modalSettings, setModalSettings] = useState({
    show: false,
    title: "Edit your preferences",
    body: (
      <>
        please send us an email at&nbsp;
        <a href="mailto:bookings@themirum.co.uk" className="text-[var(--blue)]">
          bookings@themirum.co.uk
        </a>{" "}
        for any changes to confirmed bookings
      </>
    ),
    selectionWhenDate: null,
  });
  useEffect(() => {
    let statuses = ["confirmed", "draft", "previous"];
    if (showStatus) {
      setTabsSelectedIndex(statuses.indexOf(showStatus));
    }
  }, [showStatus]);

  const { bookingHasBeenPaid } = useBookings();
  const BookingsView = ({ status }) => {
    // Ensure bookingsToShow is always an array to prevent filter errors
    let bookingsToShow = bookings || [];
    if (status) {
      let filterSatus = status.replace("previous", "confirmed");
      bookingsToShow = bookingsToShow.filter((booking) => booking.status === filterSatus);
    }

    if (status === "confirmed" || status === "previous") {
      bookingsToShow = bookingsToShow.filter((booking) => {
        let bookingForDate = moment(booking.selection?.when?.date);
        bookingForDate = bookingForDate.set({
          hour: booking.selection?.when?.startTime.split(":")[0],
          minute: booking.selection?.when?.startTime.split(":")[1],
        });
        if (bookingForDate.isAfter(moment()) && status === "confirmed") {
          return true;
        } else if (bookingForDate.isBefore(moment()) && status === "previous") {
          return true;
        } else {
          return false;
        }
      });
    }

    if (status === "draft") {
      //Put has been paid at top
      bookingsToShow = bookingsToShow.sort((a, b) => {
        if (bookingHasBeenPaid(a) && !bookingHasBeenPaid(b)) {
          return -1;
        } else if (!bookingHasBeenPaid(a) && bookingHasBeenPaid(b)) {
          return 1;
        } else {
          return 0;
        }
      });
    }

    return bookingsToShow.length === 0 && status !== "previous" ? (
      <div className="w-[200px] mx-auto hidden">
        <div className="w-1/2 mx-auto aspect-square">
          <Bubble
            shouldAnimate={true}
            animationInDelay={0}
            showAsPink={true}
            onClick={onClickedNewSurprise}
          >
            <div className="flex flex-col items-center">
              <h1>
                <FiPlus />
              </h1>
            </div>
          </Bubble>
        </div>
      </div>
    ) : (
      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-5">
        {bookingsToShow.map((booking, i) => {
          const needsToBeConfirmed =
            booking.status === "draft" && bookingHasBeenPaid(booking);

          let hasExpired = false;
          let paymentDate;
          let expiryDate;

          if (needsToBeConfirmed) {
            paymentDate = moment.unix(booking.stripe.paymentIntent.created);
            expiryDate = moment(paymentDate).add(4, "months");
            hasExpired = expiryDate.isBefore(moment());
          }

          let canClickCancel =
            booking.status === "draft" && !bookingHasBeenPaid(booking);

          let editBtnClick = null;
          if (booking.status === "draft") {
            editBtnClick = () => {
              loadAndGoToBooking(booking._id);
            };
          } else if (booking.status === "confirmed" && status != "previous") {
            let isEditableViaEmail = true;
            // moment(
            //   booking.selection?.when?.date
            // ).isAfter(moment().add(14, "days"));

            if (isEditableViaEmail) {
              editBtnClick = () => {
                // alert("email team - IS within 14 days");
                setModalSettings({
                  ...modalSettings,
                  selectionWhenDate: moment(
                    booking.selection?.when?.date
                  ).format("DD/MM/YYYY"),
                  show: true,
                });
              };
            }
          }

          return (
            <div
              className="my-4 min-h-50px"
              onClick={() => {
                if (hasExpired) {
                  return alert("Sorry, this surprise has expired.");
                }
                loadAndGoToBooking(booking._id);
              }}
            >
              <div className="w-[200px] aspect-square relative">
                <Bubble
                  isSelected={booking.status !== "draft"}
                  shouldAnimate={true}
                  animationInDelay={i * 50}
                  showAsPink={true}
                  canClickCancel={canClickCancel}
                  onClickedCancel={
                    canClickCancel
                      ? () => {
                          // alert("hello");
                          deleteBooking(booking._id);
                        }
                      : null
                  }
                  onClickedEdit={editBtnClick}
                >
                  {booking.selection?.isCorporate && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        background:
                          "linear-gradient(135deg, #1e1b24 0%, #2d2640 50%, #1a2535 100%)",
                        padding: "4px 10px",
                        borderRadius: "999px",
                        textShadow: "none",
                        fontSize: "11px",
                        lineHeight: 1.1,
                        fontWeight: 600,
                        letterSpacing: "0.2px",
                        zIndex: 2,
                      }}
                    >
                      corporate
                    </div>
                  )}
                  {needsToBeConfirmed && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        backgroundColor: "#388CFC",
                        padding: "5px 15px",
                        borderRadius: "25px",
                        textShadow: "none",
                      }}
                    >
                      paid!
                    </div>
                  )}
                  <div className="flex flex-col items-center">
                    <h1>
                      {moment(booking.selection?.when?.date).format("DD")}
                    </h1>

                    <h4>
                      {moment(booking.selection?.when?.date).format("MMMM")}
                    </h4>
                    {/* <small>{booking.status}</small> */}
                  </div>
                </Bubble>
              </div>
              {needsToBeConfirmed && (
                <div className="w-full text-center">
                  {hasExpired
                    ? `expired on ${expiryDate.format("DD/MM/YYYY")}`
                    : `valid until ${expiryDate.format("DD/MM/YYYY")}`}
                </div>
              )}
              {/* DEBUG */}
              {/* <ul>
                    <li>Booking ID: {booking._id}</li>
                    <li>For Date: {booking.selection?.when?.date}</li>
                    <li>For Time: {booking.selection?.when?.startTime}</li>
                    <li>Status: {booking.status}</li>
                    <li>
                      Payment Status:{" "}
                      {bookingHasBeenPaid(booking) ? "Paid" : "Unpaid"}
                    </li>
                  </ul> */}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <Fragment>
      <div className="container mx-auto">
        <MirumTabsGroup selectedIndex={tabsSelectedIndex}>
          <TabItem title="Upcoming">
            <BookingsView status="confirmed" />
          </TabItem>
          <TabItem title="Draft">
            <BookingsView status="draft" />
          </TabItem>
          <TabItem title="Previous">
            <BookingsView status="previous" />
          </TabItem>
        </MirumTabsGroup>
      </div>
      <MirumModal
        show={modalSettings.show}
        negativeBtnText={"cancel"}
        positiveBtnBody={"email Us"}
        onPositiveBtnClick={() => {
          window.location.href = `mailto:bookings@themirum.co.uk?subject=Booking for ${modalSettings.selectionWhenDate}`;
        }}
        onDidDismiss={() => {
          setModalSettings({
            ...modalSettings,
            show: false,
          });
        }}
      >
        <div className="p-4">
          <h1>get in touch</h1>
          <p className="my-4">{modalSettings.body}</p>
        </div>
      </MirumModal>
    </Fragment>
  );
};

export default Bookings;
